"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MuiBadgeOverrides = {
    MuiBadge: {
        styleOverrides: {
            root: () => ({
                fontSize: 12,
                fontWeight: 600,
                lineHeight: '18px',
            }),
        },
    },
};
exports.default = MuiBadgeOverrides;
//# sourceMappingURL=MuiBadgeOverrides.js.map